import React from 'react';
import { GlobeIcon, InstagramIcon, MailIcon } from 'lucide-react';
import { brand } from '../data/content';
export function SiteFooter() {
  return <footer className="w-full bg-forest-deep" data-id="element-199" data-mp="3r918ki8oup66">
      <div className="mx-auto max-w-content px-5 py-14 lg:px-8" data-id="element-200" data-mp="3mh12e820z015">
        <div className="grid gap-10 lg:grid-cols-[1.2fr_1fr]" style={{
        gap: "34px",
        width: "329px",
        height: "330px"
      }} data-id="element-201" data-mp="3mf6huuuo19xl">
          <div data-id="element-202" data-mp="3dhw515279cqk">
            <div className="flex items-center gap-2.5" data-id="element-203" data-mp="3difowrbeub78">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-gold font-display text-sm font-black text-forest-deep" data-id="element-204" data-mp="38i1i1cljp7as">
                FT
              </span>
              <span className="font-display text-base font-extrabold text-cream" data-id="element-205" data-mp="2yjlnt0r81hx2">
                {brand.name}
              </span>
            </div>
            <p className="mt-5 max-w-lg text-base leading-relaxed text-cream/70" data-id="element-206" data-mp="11q0no6azyqmm">
              Materiales digitales de educación y organización financiera para
              personas de Argentina que quieren recuperar el control de su
              economía, paso a paso.
            </p>
          </div>

          <MailIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-207" data-mp="1aqq2ldgb9r50" /><a href={`mailto:${brand.email}`} className="transition-colors duration-150 ease-out hover:text-cream" style={{
          color: "#AFADAD"
        }} data-id="element-208" data-mp="vsxo8omi38se">
                {brand.email}
              </a><ul className="space-y-3 text-sm text-cream/70 lg:justify-self-end" data-id="element-209" data-mp="1ohcykxuot2xe">
            <li className="flex items-center gap-2.5" data-id="element-210" data-mp="1ojfz4btguegd">
              
              
            </li>
            <li className="flex items-center gap-2.5" data-id="element-211" data-mp="1tiiravockq6x">
              <InstagramIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-212" data-mp="1eqibxsdj41bf" />
              {brand.instagram}
            </li>
            <li className="flex items-center gap-2.5" data-id="element-213" data-mp="1jotle1zww9t4">
              
              {brand.site}
            </li>
          </ul>
        </div>

        <div className="mt-12 border-t border-white/10 pt-8" data-id="element-214" data-mp="2c6nsbvdmdx21">
          <p className="max-w-3xl text-xs leading-relaxed text-cream/50" data-id="element-215" data-mp="2c88n9m3uji0f">
            Este producto ofrece contenido educativo general. No constituye
            asesoramiento financiero, contable, legal ni de inversión
            personalizado. Los resultados dependen de la situación, las
            decisiones y la constancia de cada persona.
          </p>
          <p className="mt-5 text-xs text-cream/50" data-id="element-216" data-mp="2823efcuzd1bk">
            © {brand.name} 2026 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}